import { useEffect, useState } from "react";

const preloadImages = (urls) => {
  urls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

// Handles slide index + autoplay for the hero background carousel.
export const useHeroCarousel = (slides, intervalMs = 5000) => {
  const [slideIdx, setSlideIdx] = useState(0);

  useEffect(() => {
    if (!slides.length) return undefined;
    const id = setInterval(() => {
      setSlideIdx((prev) => (prev + 1) % slides.length);
    }, intervalMs);
    return () => clearInterval(id);
  }, [slides.length, intervalMs]);

  useEffect(() => {
    preloadImages(slides.map((s) => s.url));
  }, [slides]);

  return [slideIdx, setSlideIdx];
};
